import React, { useEffect, useMemo, useRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks'
import { setScreensCollapsed, toggleScreenCollapse } from '../../../../../redux/reducers/formState/formStateFeature'
import { Section } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import styles from './AdditionalInformationCta.module.css'
import { FlowElementProps } from '../../../../../@types/flow-types'
import { SCREEN_ADDITIONAL_INFORMATION_CTA, ScreenName, SCREENS } from '../../../../../services/domain/wizardScreens'

const screen = SCREENS[SCREEN_ADDITIONAL_INFORMATION_CTA]

type AdditionalInformationCtaProps = {
  flowInformation?: FlowElementProps['flowInformation']
  flowName?: FlowElementProps['flowName']
  showMandatoryHint?: boolean
  screens: ScreenName[]
}

export const AdditionalInformationCta: React.FC<AdditionalInformationCtaProps> = ({ screens }) => {
  const areScreensInitialized = useRef(false)
  const initialScreensRef = useRef(screens) // snapshot at first render

  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const collapsedScreens = useAppSelector((state) => state.formStateFeature.collapsedScreens)

  const isCollapsed = useMemo(() => screens.some((screen) => collapsedScreens[screen]), [collapsedScreens, screens])

  useEffect(() => {
    if (areScreensInitialized.current) return
    areScreensInitialized.current = true

    dispatch(setScreensCollapsed({ screens: initialScreensRef.current }))
  }, [dispatch])

  const handleChange = () => {
    dispatch(toggleScreenCollapse({ screens }))
  }

  return (
    <Section
      id={screen.id}
      title={
        <span
          id={`${screen.id}-title`}
          className={`section-item-title`}
          style={{ fontSize: 'var(--size-heading-small)' }}
        >
          {t('wizard.screen.expandObjectDetailsCta.header')}
        </span>
      }
      subline={t('wizard.screen.expandObjectDetailsCta.subline')}
      variant='expandable'
      expanded={!isCollapsed}
      onChange={handleChange}
      className={`one-whole margin-bottom-xl ${styles.noEmptyBottomSpaceWhenExpanded}`}
    />
  )
}
